var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 720.0l-960.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 720.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665l185.0622 -264.9421z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeDasharray: "72.0,96.0,0.0,96.0",
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m276.67044 583.24207l0 0c-6.3268433 -62.001465 28.809174 -121.8909 91.51492 -155.98737c62.70578 -34.096497 142.88492 -36.910126 208.83386 -7.3283386c65.94891 29.581787 107.04907 86.79596 107.04907 149.0195l-204.06299 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m276.67044 583.24207l0 0c-6.3268433 -62.001465 28.809174 -121.8909 91.51492 -155.98737c62.70578 -34.096497 142.88492 -36.910126 208.83386 -7.3283386c65.94891 29.581787 107.04907 86.79596 107.04907 149.0195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "m276.67044 583.24207l0 0c-6.3268433 -62.001465 28.809174 -121.8909 91.51492 -155.98737c62.70578 -34.096497 142.88492 -36.910126 208.83386 -7.3283386c65.94891 29.581787 107.04907 86.79596 107.04907 149.0195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m333.71756 248.48756l0 0c0 -80.790115 65.49332 -146.28345 146.28345 -146.28345l0 0c38.796783 0 76.00455 15.411957 103.43802 42.845436c27.433472 27.433472 42.84546 64.641235 42.84546 103.43802l0 0c0 80.790146 -65.49335 146.28346 -146.28348 146.28346l0 0c-80.79013 0 -146.28345 -65.49332 -146.28345 -146.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m333.71756 248.48756l0 0c0 -80.790115 65.49332 -146.28345 146.28345 -146.28345l0 0c38.796783 0 76.00455 15.411957 103.43802 42.845436c27.433472 27.433472 42.84546 64.641235 42.84546 103.43802l0 0c0 80.790146 -65.49335 146.28346 -146.28348 146.28346l0 0c-80.79013 0 -146.28345 -65.49332 -146.28345 -146.28346z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIUser);
export default __webpack_public_path__ + "static/media/IUser.6a25298e44f05e84997272cca0538dd0.svg";
export { ForwardRef as ReactComponent };